"use strict";
// _partialFile.js

{
  document.addEventListener("DOMContentLoaded", function () {
    const grid = document.getElementById("articleGrid"); // 記事リスト
    const btn = document.querySelector(".p-article__viewMoreBtn"); // ボタン
    const viewMoreWrap = btn ? btn.closest(".p-article__viewMore") : null; // ラッパー

    if (!grid || !btn || !viewMoreWrap) return;

    // 5件以下ならボタン全体を隠す
    const items = grid.children.length;
    if (items <= 5) {
      viewMoreWrap.style.display = "none";
      return;
    }

    btn.addEventListener("click", function () {
      grid.classList.add("-expanded"); // 6件目以降を表示
      btn.setAttribute("aria-expanded", "true");

      // ボタンとタイトルごと消す
      viewMoreWrap.style.display = "none";
    });
  });
}
